import { render, staticRenderFns } from "./VisitorAttractions.vue?vue&type=template&id=b79e278e&scoped=true"
import script from "./VisitorAttractions.vue?vue&type=script&lang=js"
export * from "./VisitorAttractions.vue?vue&type=script&lang=js"
import style0 from "./VisitorAttractions.vue?vue&type=style&index=0&id=b79e278e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79e278e",
  null
  
)

export default component.exports